import AppConstants from '../../Constants/AppConstants';

export const attributeValueDraftKey = attributeID =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:attribute-values:${attributeID || 'unknown'}`;

export const readAttributeValueDraft = key => {
  try {
    const draft = JSON.parse(window.localStorage.getItem(key) || '{}');
    return draft && typeof draft === 'object' ? draft : {};
  } catch (error) {
    return {};
  }
};

const cleanMetadata = values => (Array.isArray(values) ? values : [])
  .slice(0, 100)
  .filter(item => item && typeof item === 'object')
  .map(item => ({
    key: String(item.key || '').slice(0, 200),
    // Metadata values are user-defined and may contain credentials or tokens.
    value: '',
  }))
  .filter(item => item.key && !/password|token|secret|credential|authorization|bearer|file|image/i.test(item.key));

export const writeAttributeValueDraft = (key, state) => {
  try {
    const translationValues = (Array.isArray(state.translationValues) ? state.translationValues : [])
      .filter(item => item && typeof item.locale === 'string')
      .slice(0, 50)
      .map(item => ({locale: item.locale, value: String(item.value || '').slice(0, 2000)}));
    window.localStorage.setItem(key, JSON.stringify({
      valuesArray: (Array.isArray(state.valuesArray) ? state.valuesArray : [])
        .filter(value => typeof value === 'string')
        .slice(0, 300)
        .map(value => value.slice(0, 2000)),
      statusSwitchValue: Boolean(state.statusSwitchValue),
      isEdit: Boolean(state.isEdit),
      selectedID: String(state.selectedID || ''),
      selectedValueID: String(state.selectedValue?.id || ''),
      translationValues,
      metadata: cleanMetadata(state.metadata),
    }));
  } catch (error) {
    // Local storage is optional; keep the editor usable if it is unavailable.
  }
};

export const clearAttributeValueDraft = key => {
  try { window.localStorage.removeItem(key); }
  catch (error) { /* Ignore storage errors after save or explicit discard. */ }
};
